import type { FormState, DateRange } from '../types'
import { parseStringToList, parseStringToDayjs, parseDayjsToString } from './parse'
import { resolvePeriod, expandToFullDayRange, daysOf, presetRange } from './date-range'

export type DateKeys = {
  from: string
  to: string
}

export type ConverterConfig = {
  dateKeys: DateKeys
}

/** Converte filtros vindos da API para o estado inicial do Formik */
export const buildFormState = (
  filters: Record<string, unknown>,
  config: ConverterConfig,
): FormState => {
  const dateRange: DateRange = [
    parseStringToDayjs(filters[config.dateKeys.from]),
    parseStringToDayjs(filters[config.dateKeys.to]),
  ]

  return {
    status: parseStringToList(filters.status),
    method: parseStringToList(filters.method),
    dateRange,
    period: resolvePeriod(filters.activePeriod, dateRange.some(Boolean)),
    stationName: typeof filters.stationName === 'string' ? filters.stationName : '',
  }
}

/** Converte o estado do Formik de volta para um payload de filtros da API */
export const buildAppliedFilters = (
  form: FormState,
  config: ConverterConfig,
): Record<string, unknown> => {
  const isPreset = daysOf(form.period as string) > 0
  const [from, to] = isPreset
    ? presetRange(form.period as string)
    : expandToFullDayRange(form.dateRange)

  const applied: Record<string, unknown> = {
    status: (form.status as string[]).join(','),
    method: (form.method as string[]).join(','),
    [config.dateKeys.from]: parseDayjsToString(from),
    [config.dateKeys.to]: parseDayjsToString(to),
    stationName: form.stationName.trim() || undefined,
    activePeriod: isPreset ? form.period : '',
  }

  return Object.fromEntries(
    Object.entries(applied).filter(([, value]) => value),
  )
}
